import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React from 'react';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';
import { InfoSection } from '../styles';
import FAQ from '@spa/offer/components/FAQ';
import { Main, SectionPlaceholder } from './styles';
import Gallery from '@spa/offer/components/Gallery';
import Reviews from '@spa/offer/components/Reviews';
import { useInView } from '@spa/shared/hooks/inView';
import Contract from '@spa/offer/components/Contract';
import Landlord from '@spa/offer/components/Landlord';
import Overview from '@spa/offer/components/Overview';
import Breadcrumbs from '@spa/offer/components/Breadcrumbs';
import Availability from '@spa/offer/components/Availability';
import Separator from '@spa/shared/components/Unisystem/Separator';
import ServicesExpenses from '@spa/offer/components/ServicesExpenses';
import RentalConditions from '@spa/offer/components/RentalConditions';
import PricingBoxMobile from '@spa/offer/components/PricingBox/Mobile';
import HeaderTitleMobile from '@spa/offer/components/HeaderTitle/Mobile';
import MorePlacesLikeThis from '@spa/offer/components/MorePlacesLikeThis';
import WhyRentWithUniplaces from '@spa/offer/components/WhyRentWithUniplaces';
import RegistrationNumber from '@spa/shared/components/RegistrationNumber';
var WhereYoullBeLiving = dynamic(function () {
  return import('@spa/offer/components/WhereYoullBeLiving');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('@spa/offer/components/WhereYoullBeLiving')];
    }
  }
});
var OfferViewMobile = function OfferViewMobile(_ref) {
  var rentalRegistrationCode = _ref.rentalRegistrationCode;
  var _useInView = useInView({
      triggerOnce: true,
      rootMargin: '200px 0px'
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    whereYoullBeLivingRef = _useInView2[0],
    isWhereYoullBeLivingInView = _useInView2[1];
  return __jsx(React.Fragment, null, __jsx(Gallery, null), __jsx(Main, null, __jsx(HeaderTitleMobile, null), __jsx(Separator, null), __jsx(Overview, null), __jsx(Separator, null), __jsx(Availability, null), __jsx(Separator, null), __jsx(Landlord, null), __jsx(Separator, null), __jsx(ServicesExpenses, null), __jsx(Separator, null), __jsx(RentalConditions, null), __jsx(Separator, null), __jsx(Contract, null), __jsx(Separator, null), __jsx("div", {
    ref: whereYoullBeLivingRef
  }, isWhereYoullBeLivingInView ? __jsx(WhereYoullBeLiving, null) : __jsx(SectionPlaceholder, null)), __jsx(Reviews, null), __jsx(WhyRentWithUniplaces, null), __jsx(FAQ, null), __jsx(MorePlacesLikeThis, null), __jsx(PricingBoxMobile, null), __jsx(InfoSection, null, rentalRegistrationCode && __jsx(RegistrationNumber, {
    registrationNumber: rentalRegistrationCode
  }), __jsx(Breadcrumbs, null))));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var _contract$landlord_po, _contract$landlord_po2;
  var contract = _ref2.offer.offerAggregate.accommodation_offer.contract;
  return {
    rentalRegistrationCode: contract === null || contract === void 0 ? void 0 : (_contract$landlord_po = contract.landlord_policies) === null || _contract$landlord_po === void 0 ? void 0 : (_contract$landlord_po2 = _contract$landlord_po.rental_registration_code) === null || _contract$landlord_po2 === void 0 ? void 0 : _contract$landlord_po2.value
  };
};
export default connect(mapStateToProps)(OfferViewMobile);